import React from 'react';
import { useSelector } from 'react-redux';
import ComboBox from './Ui/ComboBox/ComboBox';
import useWeather from '../hooks/useWeather';

const SelectionCard = ({ title, value, items, onChange, sx }) => (
  <div className="bg-white py-2 px-3 rounded-xl shadow-[0_2px_10px_rgba(0,0,0,0.03)] flex flex-col justify-center">
    <p className="text-sm font-bold text-[#77b054] uppercase mb-2 tracking-wider pl-1">
      {title}
    </p>
    <ComboBox
      sx={{
        width: '100%',
        height: '42px',
        borderRadius: '8px',
        backgroundColor: '#FFF',
        '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #e1e8ed' },
        fontSize: '14px',
        fontWeight: 600,
        ...sx,
      }}
      items={items}
      value={value}
      onChange={onChange}
    />
  </div>
);

const WeatherInfoCard = ({ label, temp, Icon, color, bg }) => (
  <div className="bg-white p-5 rounded-xl shadow-[0_2px_10px_rgba(0,0,0,0.03)] flex items-center justify-between">
    <div>
      <p className="text-xs font-medium text-[#7f8c8d] mb-1">{label}</p>
      <h4 className="text-xl font-bold text-[#2c3e50]">{temp}°C</h4>
    </div>
    <div
      className="w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-500"
      style={{ backgroundColor: bg }}
    >
      <Icon style={{ color: color, fontSize: 22 }} />
    </div>
  </div>
);

export default function Header({
  headerInputs,
  SearchLogic2,
  SearchLogic3,
  SearchLogic4,
  handleCoChange,
  handleCustChange,
}) {
  const searchInfo = useSelector((state) => state.SearchInfo);

  const {
    currentTemp,
    CurrentIcon,
    currentColor,
    currentBg,
    tomorrowTemp,
    TomorrowIcon,
    tomorrowColor,
    tomorrowBg,
  } = useWeather();

  return (
    <div className="w-full bg-[#f0f3f6] px-6 py-2">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/*  회사 선택 (ADMIN 전용) */}
        {headerInputs.authCd === 'ADMIN' && (
          <SelectionCard
            title="회사 선택"
            items={searchInfo.coList || []}
            value={searchInfo.coCd || ''}
            onChange={async (e) => {
              const nextCustCd = await handleCoChange(e);
              await SearchLogic2?.();
              await SearchLogic3?.(nextCustCd);
              await SearchLogic4?.(nextCustCd);
            }}
          />
        )}

        {/*  사업장 선택 (ADMIN·일반 공통) */}
        <SelectionCard
          title="사업장 선택"
          items={searchInfo.custList || []}
          value={searchInfo.custCd || ''}
          onChange={async (e) => {
            const newCustCd = await handleCustChange(e);
            await SearchLogic2?.();
            await SearchLogic3?.(newCustCd);
            await SearchLogic4?.(newCustCd);
          }}
        />

        {/*  오늘 날씨 */}
        <WeatherInfoCard
          label="오늘의 기온"
          temp={currentTemp}
          Icon={CurrentIcon}
          color={currentColor}
          bg={currentBg}
        />

        {/*  내일 날씨 */}
        <WeatherInfoCard
          label="내일 예보"
          temp={tomorrowTemp}
          Icon={TomorrowIcon}
          color={tomorrowColor}
          bg={tomorrowBg}
        />
      </div>
    </div>
  );
}
